import { render, staticRenderFns } from "./DiabetesKnowledgePosts.vue?vue&type=template&id=3e9ed4ad"
import script from "./DiabetesKnowledgePosts.vue?vue&type=script&lang=js"
export * from "./DiabetesKnowledgePosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports